import React from "react";
import ReportingChart from "../Reporting/ReportingChart";
import _ from "lodash-es";
import gql from "graphql-tag";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

const ECRITURELINE_CREATED_SUBSCRIPTION = gql`
  subscription onEcritureLineCreated($companyId: ID!) {
    ecritureLineCreated(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const ECRITURELINE_UPDATED_SUBSCRIPTION = gql`
  subscription onEcritureLineUpdated($companyId: ID!) {
    ecritureLineUpdated(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const ECRITURELINE_DELETED_SUBSCRIPTION = gql`
  subscription onEcritureLineDeleted($companyId: ID!) {
    ecritureLineDeleted(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const LETTRAGE_DONE = gql`
  subscription onEcritureLineLettrageDone($companyId: ID!) {
    ecritureLineLettrageDone(companyId: $companyId) {
      date
    }
  }
`;

class RentabilityChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.startCursorArray = [];
    //console.log("13 - props", props);
    // const data = props.data && props.data.ecritureLinesConnectionForRentability;

    // const pageInfo = data && data.pageInfo;

    // if (pageInfo.hasNextPage) {
    //   props.onLoadMore(
    //     pageInfo.endCursor,
    //     "ecritureLinesConnectionForRentability"
    //   );
    // }
  }

  componentDidUpdate() {
    const data =
      this.props.data && this.props.data.ecritureLinesConnectionForRentability;

    if (!!!data) {
      this.startCursorArray = [];
      return;
    }

    const pageInfo = data && data.pageInfo;
    // console.log("128 - pageInfo=", pageInfo);
    // console.log("129 - data=", this.props.data.ecritureLinesConnectionForRentability);
    // console.log("130 - data=", this.props.data._ecritureLinesForRentabilityMeta);

    const startCursor = pageInfo && pageInfo.startCursor;
    if (this.startCursorArray.includes(startCursor)) {
      console.log("146 - already in array:", startCursor, pageInfo);
      return;
    }
    else
      this.startCursorArray.push(startCursor);

    if (pageInfo.hasNextPage) {
      console.log("140 - LoadMore...", startCursor);
      this.props.onLoadMore(
        pageInfo.endCursor,
        "ecritureLinesConnectionForRentability"
      );
    }
    // else
    //   this.startCursorArray = []
  }

  componentDidMount() {
    // console.log("104 - RentabilityChart.componentDidMount", this);
    this.startCursorArray = [];

    if (!this.props.data) return;

    // this.startCursorArray = [];

    // ecritureLineCreated
    if (this.unsubscribeEcritureLineCreated)
      this.unsubscribeEcritureLineCreated();
    this.unsubscribeEcritureLineCreated = this.props.subscribeToMore({
      document: ECRITURELINE_CREATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        console.log("176 - ECRITURELINE_CREATED_SUBSCRIPTION...");
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // ecritureLineUpdated
    if (this.unsubscribeEcritureLineUpdated)
      this.unsubscribeEcritureLineUpdated();
    this.unsubscribeEcritureLineUpdated = this.props.subscribeToMore({
      document: ECRITURELINE_UPDATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        //this.props.refetch();
        // console.log("197 - ECRITURELINE_UPDATED_SUBSCRIPTION...");
        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // ecritureLineDeleted
    if (this.unsubscribeEcritureLineDeleted)
      this.unsubscribeEcritureLineDeleted();
    this.unsubscribeEcritureLineDeleted = this.props.subscribeToMore({
      document: ECRITURELINE_DELETED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        console.log("215 - ECRITURELINE_DELETED_SUBSCRIPTION...");
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // lettageDoneCreated
    if (this.unsubscribeLettageDone)
      this.unsubscribeLettageDone();
    this.unsubscribeLettageDone = this.props.subscribeToMore({
      document: LETTRAGE_DONE,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        console.log("235 - LETTRAGE_DONE...");
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });
    return;
  }

  componentWillUnmount() {
    if (this.unsubscribeEcritureLineCreated)
      this.unsubscribeEcritureLineCreated();

    if (this.unsubscribeEcritureLineUpdated)
      this.unsubscribeEcritureLineUpdated();

    if (this.unsubscribeEcritureLineDeleted)
      this.unsubscribeEcritureLineDeleted();

    if (this.unsubscribeLettageDone)
      this.unsubscribeLettageDone();
  }

  static getDerivedStateFromProps = async (props, state) => {
    // console.log("230 - getDerivedStateFromProps", props);
    console.log("263 - getDerivedStateFromProps", props.data);

    if (
      props &&
      props.data &&
      props.data.ecritureLinesConnectionForRentability
    ) {
      state.data = props.data;

      let edges =
        state &&
        state.data &&
        state.data.ecritureLinesConnectionForRentability &&
        state.data.ecritureLinesConnectionForRentability.edges;

      // bank transaction -> bank name 
      // _.forEach(edges, o => {
      //   if (o.node && o.node.bankTransaction !== null) {

      //     if (o.node.tiers === null) {
      //       const fakeTiers = {
      //         id: "fake_" + o.node.bankTransaction.bankAccount.id,
      //         name: o.node.bankTransaction.bankAccount.name,
      //         client: null,
      //         group: null
      //       }
      //       o.node.tiers = fakeTiers;
      //     }
      //   }
      // });

      // // TRANSLATIONS.....
      _.forEach(edges, o => {
        if (o.node && o.node.category && o.node.category.ids !== null) {
          // console.log("=>", o.node.category.ids);
          o.node.category.name = props.intl.formatMessage({
            id: o.node.category.ids
          });
        }

        if (
          o.node &&
          o.node.category &&
          o.node.category &&
          o.node.category.categoryFamily &&
          o.node.category.categoryFamily.ids !== null
        ) {
          o.node.category.categoryFamily.name = props.intl.formatMessage({
            id: o.node.category.categoryFamily.ids
          });
        }

        if (o.node && o.node.tiersClient && o.node.tiersClient.id === "FAKE_ID_CLIENT") {
          o.node.tiersClient.name = props.intl.formatMessage({
            id: o.node.tiersClient.name
          });
        }
        if (o.node && o.node.project && o.node.project.id === "FAKE_ID_PROJECT") {
          o.node.project.name = props.intl.formatMessage({
            id: o.node.project.name
          });
        }
      });

      if (edges) {
        edges = _.orderBy(
          edges,
          [
            "node.project.name",
            "node.category.name",
            "node.tiers.name",
            "node.article.name",
            "node.category.categoryFamily.name",
            "node.category.name"
          ],
          ["asc", "asc", "asc", "asc", "asc", "asc"]
        );
        state.data.ecritureLinesConnectionForRentability.edges = edges;
      }
    }
  };

  render() {
    const edges =
      this.state.data &&
      this.state.data.ecritureLinesConnectionForRentability &&
      this.state.data.ecritureLinesConnectionForRentability.edges;

    return (
      <div>
        <ReportingChart
          {...this.props}
          edges={edges}
          negateValues={true}
          type="rentability"
          splitAmountsByCategory={false}
          allowNegative={false}
          displayLines={false}
          tabs={["client", "project", "categories"]}
          onRowClick={(id, state, rowInfo, column, instance) => {
            console.log("RentabilityChart rowInfo", rowInfo);

            if (rowInfo.original.expense) {
              this.props.history.push(
                `/expenses/${rowInfo.original.expense.id}/edit`
              );
            } else if (rowInfo.original.bankTransaction) {
              this.props.history.push(
                `/payments/${rowInfo.original.bankTransaction.id}/affectation`
              );
            } else if (rowInfo.original.invoice) {
              this.props.history.push(
                `/invoices/${rowInfo.original.invoice.id}/edit`
              );
            }

            // if (rowInfo.original.id) {
            //   this.props.history.push(
            //     `/expenses/${rowInfo.original.id}/edit`
            //   );
            // }

            // this.props.history.push(
            //   `/expenses/${rowInfo.original.expense.id}/edit`
            // );
          }}
        />
      </div>
    );
  }
}

export default withRouter(injectIntl(RentabilityChart));
